/** Official exams (docs/14 B11): types set by the organization, sittings scheduled, recorded and approved. */
import { z } from "zod";
const surah = z.number().int().min(1).max(114);
const ayah = z.number().int().min(1).max(286);
export const ExamKind = z.enum(["juz_end", "multi_juz", "periodic", "final", "ijaza", "other"]);
export const ExamApprover = z.enum(["supervisor", "org_admin"]);
export const ExamStatus = z.enum(["scheduled", "recorded", "approved", "cancelled"]);
export const ExamTypeBody = z
    .object({
    organizationId: z.uuid(),
    name: z.string().trim().min(2).max(80),
    kind: ExamKind,
    maxScore: z.number().positive().max(1000),
    passScore: z.number().min(0).max(1000),
    maxAttempts: z.number().int().min(1).max(20),
    approverRole: ExamApprover,
})
    .refine((t) => t.passScore <= t.maxScore, { message: "درجة النجاح أكبر من الدرجة العظمى", path: ["passScore"] });
export const ExamType = z.object({
    id: z.uuid(),
    name: z.string(),
    kind: ExamKind,
    maxScore: z.number(),
    passScore: z.number(),
    maxAttempts: z.number(),
    approverRole: ExamApprover,
    archived: z.boolean(),
});
export const ExamTypesResponse = z.object({ examTypes: z.array(ExamType) });
export const ScheduleExamBody = z.object({
    enrollmentId: z.uuid(),
    examTypeId: z.uuid(),
    start: z.object({ surah, ayah }),
    end: z.object({ surah, ayah }),
    scheduledOn: z.iso.date(),
    examinerId: z.uuid(),
});
export const RecordExamBody = z.object({
    score: z.number().min(0).max(1000),
    studentNote: z.string().trim().max(1000).optional(),
    examinerNote: z.string().trim().max(2000).optional(),
});
export const Exam = z.object({
    id: z.uuid(),
    student: z.object({ id: z.uuid(), name: z.string() }),
    circle: z.object({ id: z.uuid(), name: z.string() }),
    type: z.object({ id: z.uuid(), name: z.string(), kind: ExamKind }),
    attempt: z.number(),
    maxAttempts: z.number(),
    range: z.string(),
    startAyah: z.number(),
    endAyah: z.number(),
    scheduledOn: z.string(),
    examiner: z.object({ id: z.uuid(), name: z.string() }),
    status: ExamStatus,
    maxScore: z.number(),
    passScore: z.number(),
    /** Null until recorded; hidden from the student until approved. */
    score: z.number().nullable(),
    passed: z.boolean().nullable(),
    studentNote: z.string().nullable(),
    /** Staff only. */
    examinerNote: z.string().nullable().optional(),
    approverRole: ExamApprover,
    approvedAt: z.string().nullable(),
    /** What the caller may do now. */
    can: z.object({ record: z.boolean(), approve: z.boolean(), cancel: z.boolean() }),
});
export const ExamsQuery = z.object({
    enrollmentId: z.uuid().optional(),
    circleId: z.uuid().optional(),
    /** Exams the caller examines. */
    mine: z.enum(["examiner"]).optional(),
    status: ExamStatus.optional(),
});
export const ExamsResponse = z.object({ exams: z.array(Exam) });
export const ExamResponse = z.object({ exam: Exam });
export const ExaminersResponse = z.object({
    examiners: z.array(z.object({ id: z.uuid(), name: z.string(), role: z.string() })),
});
//# sourceMappingURL=exams.js.map